export default __webpack_public_path__ + "static/media/loupe.a7b4ffd7.png";